// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609111534/js/" + chunkId + "." + {"44":"af1b261c","225":"8d473f02","481":"2cd5e5d1","486":"eb50bd94","770":"4fa67316"}[chunkId] + ".0.005512333053827256.chunk.js";
};